import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import LeafletHub from '../LeafletHub';
import LeafletDetail from '../LeafletDetail';
import ReactGA from 'react-ga4';
import Header from './components/Header';
import { IS_MARTGO_APP } from 'src/utils/constants';
import SystemLauncher from '../SystemLauncher';

function App(): React.ReactElement {
  const location = useLocation();
  /**
   * @name GA 설정
   */
  useEffect(() => {
    if (process.env.REACT_APP_GA_TRACKING_ID) {
      ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
    }
  }, []);

  /**
   * @name 카카오 설정
   */
  useEffect(() => {
    if (window.Kakao) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_KEY);
      }
    }
  }, []);

  return (
    <>
      {!IS_MARTGO_APP && location.pathname === '/' && <Header />}
      <Routes>
        {/* 전단 허브 */}
        <Route path="/" element={<LeafletHub />} />
        {/* 전단 상세 */}
        <Route path="/:leaflet_id" element={<LeafletDetail />} />
        {/* 전단 중계페이지 */}
        <Route path="/system/launcher" element={<SystemLauncher />} />
      </Routes>
    </>
  );
}

export default App;
